import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { FRONT_PAGE_PATH, SIGN_OUT_PATH, WORK_ORDER_ID_PATH, WORK_LOG_PATH, CUSTOMER_SEARCH, CUSTOMER_INFO_PATH, SSO_PATH, } from '../constants/paths';
import InfoBox from '../components/InfoBox/InfoBox';
import SignOut from '../modules/Authentication/containers/SignOutContainer';
import WorkOrderListContainer from '../modules/WorkorderList/containers/work-order-list-container';
import { WorkLogContainer } from '../modules/WorkLog/containers/work-log-container';
import { CustomerSearch } from '../features/customer-search';
import WorkOrderPage from '../modules/Workorder/containers/work-order-page/work-order-page';
import { CustomerPage } from '../modules/Workorder/containers/customer-page/customer-page';
const WorkOrderPageWrapper = () => {
    const { id } = useParams();
    const numericId = Number(id);
    return _jsx(WorkOrderPage, { workOrderId: numericId });
};
const CustomerPageWrapper = () => {
    const { customerId } = useParams();
    const numericId = Number(customerId);
    return _jsx(CustomerPage, { customerId: numericId });
};
const WorkLogContainerWrapper = () => {
    const { id } = useParams();
    const parsedId = Number(id !== null && id !== void 0 ? id : 0);
    return _jsx(WorkLogContainer, { workOrderId: parsedId });
};
const AppRoutes = () => (_jsxs(Routes, { children: [_jsx(Route, { path: SSO_PATH, element: _jsx(Navigate, { to: FRONT_PAGE_PATH, replace: true }) }), _jsx(Route, { path: FRONT_PAGE_PATH, element: _jsx(WorkOrderListContainer, {}) }), _jsx(Route, { path: WORK_ORDER_ID_PATH, element: _jsx(WorkOrderPageWrapper, {}) }), _jsx(Route, { path: CUSTOMER_INFO_PATH, element: _jsx(CustomerPageWrapper, {}) }), _jsx(Route, { path: SIGN_OUT_PATH, element: _jsx(SignOut, {}) }), _jsx(Route, { path: WORK_LOG_PATH, element: _jsx(WorkLogContainerWrapper, {}) }), _jsx(Route, { path: CUSTOMER_SEARCH, element: _jsx(CustomerSearch, {}) }), _jsx(Route, { path: "*", element: _jsx("div", { className: "no__know__route", children: _jsx(InfoBox, {}) }) })] }));
export default AppRoutes;
